import { supabase } from '../lib/supabase';

export const projectChangeOrderService = {
  async getByProject(projectId) {
    const { data, error } = await supabase?.from('project_change_orders')?.select(`
        *,
        created_by_profile:user_profiles!project_change_orders_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_change_orders_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.eq('project_id', projectId)?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async create(projectId, { title, description, impact }, userId) {
    const { data, error } = await supabase?.from('project_change_orders')?.insert({
      project_id: projectId,
      title,
      description,
      impact,
      created_by: userId,
      updated_by: userId,
    })?.select(`
        *,
        created_by_profile:user_profiles!project_change_orders_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_change_orders_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.single();
    if (error) throw error;
    return data;
  },

  async update(changeOrderId, { title, description, impact }, userId) {
    const { data, error } = await supabase?.from('project_change_orders')?.update({
      title,
      description,
      impact,
      updated_by: userId,
    })?.eq('id', changeOrderId)?.select(`
        *,
        created_by_profile:user_profiles!project_change_orders_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_change_orders_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.single();
    if (error) throw error;
    return data;
  },

  async delete(changeOrderId) {
    const { error } = await supabase?.from('project_change_orders')?.delete()?.eq('id', changeOrderId);
    if (error) throw error;
  },
};
